import React, { createContext, useContext } from 'react';
import { useState, useEffect } from 'react';
import useFetch from '../hooks/useFetch';
const AuthContext = createContext();

function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const { post } = useFetch();

    function setLocalToken(token) {
        localStorage.setItem('authToken', token);
        setToken(token);
    }

    function setLocalUser(user) {
        localStorage.setItem('userData', JSON.stringify(user));
        setUser(user);
    }

    function getToken() {
        return localStorage.getItem('authToken');
    }

    function getUser() {
        return JSON.parse(localStorage.getItem('userData'));
    }

    useEffect(() => {
        const validateToken = async () => {
            console.log("AuthContext.js useEffect");
            const storageData = localStorage.getItem('authToken');
            if (storageData) {
                setToken(storageData);
                return storageData;
            } else {
                setToken('');
            }
        }

        const getUserInformation = async () => {
            const storageData = localStorage.getItem('userData');
            if(storageData) {
                const userObj = JSON.parse(storageData);
                setUser(userObj);
                return userObj;
            } else {
                setUser('');
            }
        }

        validateToken();
        getUserInformation(); 
    }, []);

    async function signin(email, senha) {
        console.log("AuthContext.js signin");

        let fetchBody = {
            email: email,
            senha: senha
        };
        
        try {
            const response = await post("/login", fetchBody);
            if (response.ok) {
                const dados = response.result.data;
                if (dados.token) {
                    setLocalUser(dados.usuario);
                    setLocalToken(dados.token);
                    return true;
                }
                return false;
            }
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }

    async function signout() {
        setLocalUser('');
        setLocalToken('');
    }

    return (
        <AuthContext.Provider value={{ user, token, signin, signout, getToken, getUser }}>
            {children}
        </AuthContext.Provider>
    )
}

export { AuthContext, AuthProvider };